<template>
  <div class="page-nav">
    <b-field :addons="true">
       <!-- <div class="control">
	<b-tooltip
	  position="is-left"
	  :active="hasTags"
    :label="$t('Show tags')"
	  class="is-family-primary"
	>
	  <button
	    class="button"
	    :disabled="!hasTags"
	    @click="handleClick(value - 1)"
	  >
	    <b-icon icon="tags" />
	  </button>
	</b-tooltip>
      </div> -->
      <div class="control">
	<b-tooltip
	  position="is-left"
	  :active="hasPrev"
    :label="$t('Go to previous page')"
	  class="is-family-primary"
	>
	  <button
	    class="button"
	    :disabled="!hasPrev"
	    @click="handleClick(value - 1)"
	  >
	    <b-icon icon="chevron-left" />
	  </button>
	</b-tooltip>
      </div>
      <div class="control">
	<b-tooltip
	  position="is-left"
	  :label="$t('Set page number')"
	  class="is-family-primary"
	>
	  <input
	    ref="input"
	    class="input is-family-primary"
	    :value="Number.isNaN(value) ? '' : value"
	    @focus="handleFocus"
	    @keypress.enter="handleKeypress($event)"
	    style="text-align: center; width: 4rem"
	  >
	</b-tooltip>
      </div>
      <div class="control">
	<b-tooltip
	  position="is-left"
	  :label="$t('Nr. of pages')"
	  class="is-family-primary"
	>
	  <div class="button is-family-primary" style="width: 4rem">{{ Number.isNaN(max) ? '' : max }}</div>
	</b-tooltip>
      </div>
      <div class="control">
	<b-tooltip
	  position="is-left"
	  class="is-family-primary"
	  :label="$t('Go to page')"
	>
	  <b-button
	    @click.prevent="handleSubmit"
	    class="button"
	  >
	    {{$t('Go')}}
	  </b-button>
	</b-tooltip>
      </div>
      <div class="control">
	<b-tooltip
	  position="is-left"
	  :active="hasNext"
	  :label="$t('Go to next page')"
	  class="is-family-primary"
	>
	  <button
	    class="button"
	    :disabled="!hasNext"
	    @click="handleClick(value + 1)"
	  >
	    <b-icon icon="chevron-right" />
	  </button>
	</b-tooltip>
      </div>
    </b-field>
  </div>
</template>

<style>
 .nav-page {
   display: flex !important;
   flex-flow: row nowrap !important;

   align-items: center;
 }

 .nav-page .input {
   text-align: center;
   min-width: 70px;
   flex: 0;
 }

 .nav-page span.button {
   text-align: center;
 }

</style>

<script>
 export default {
   props: {
     value: {
       type: Number,
       required: true
     },
     max: {
       type: Number,
       required: true
     }
   },
   computed: {
     hasNext() {
       return this.value < this.max
     },
     hasPrev() {
       return this.value > 1
     }
   },
   methods: {
     handleKeypress(event) {
       if (event.target) this.$emit('input', this.sanitize(event.target.value))
     },
     handleSubmit() {
       if (this.$refs.input) this.$emit('input', this.sanitize(this.$refs.input.value))
     },
     handleClick(value) {
       this.$emit('input', this.sanitize(value))
     },
     handleFocus(event) {
       if (event.target) this.select()
     },
     select(event) {
       if (this.$refs.input) this.$refs.input.select()
     },
     restore() {
       this.$refs.input.value = this.value
     },
     sanitize(value) {
       if (typeof value !== 'number') value = Number(value)
       if (Number.isNaN(value)) {
	 this.restore()
	 this.select()
	 return this.value
       }
       return Math.min(Math.max(1, value), this.max)
     }
   }
 }
</script>
